import { StatusValues } from './StatusValues';

export enum AdditionalStatusValues {
  signed = 'signed',
  notSigned = 'notSigned',
  multipleSignatures = 'multipleSignatures',
}

export const VerificationStatusValues = {...AdditionalStatusValues, ...StatusValues};
